module.exports = __webpack_public_path__ + "static/media/Explore_User_Guide_Icon_White.7bea1636.svg";